import React from 'react';

const WhatsAppButton: React.FC = () => {
    return (
        <a
            href="https://wa.me/51925714702?text=Hola me gustaría tener más información sobre el producto"
            target="_blank"
            rel="noopener noreferrer"
            className="whatsapp"
            aria-label="Contact us on WhatsApp"
        >
            <i className="uil uil-whatsapp"></i>
        </a>
    );
};

export default WhatsAppButton;
